@if (logos(); as logos) {
    <div
        class="inner-page-wrapper border-grey-100 flex flex-wrap justify-center gap-x-56 gap-y-24 border-b-1 py-24 md:mb-8 md:justify-start md:pt-40"
    >
        @for (item of logos; track item) {
            @if (item) {
                <ui-m000-c010-image
                    class="block"
                    [image]="{
                        image: item.url,
                        desktop: { width: 260, height: 60 },
                        tablet: { width: 260, height: 60 },
                        mobile: { width: 260, height: 60 },
                    }"
                    [priority]="false"
                    [alt]="item.alt || 'Logo'"
                    classList="aspect-[260/60]"
                    contain
                />
            }
        }
    </div>
}
